import {} from "react";
import { useNavigate, generatePath, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
// import { logoutUser } from "../store/slices/UserSlice";
import userIcon from "../assets/img/UserImage.png";
import mem from "../assets/img/memlogo.png";
import pro from "../assets/img/plogo.png";
import CalendarClock from "../assets/img/calendar-clock.png";
// import lout from "../assets/img/signout.png";
import lead from "../assets/img/leadlogo.png";
import fra from "../assets/img/Frame.png";
import insplogo from "../assets/img/insplogo.png";
import adminlogo from "../assets/img/admlogo.png";
import navbarimg from "../assets/img/navbar.png";
import logo from "../assets/img/Full logo blue.png";
import actonlogo from "../assets/img/actionlogo.png";
// import qrcodelogo from "../assets/img/qrlogo.png";
import settings from "../assets/img/sett.png";
import backgroundImg from "../assets/img/docsupport.png";
// import clientProfile from "../assets/img/ClientProfile.png";
import { Persona, PersonaSize } from "@fluentui/react";
import { useEffect, useState } from "react";
import http from "../api/server";
import { GET_USER_PROFILEDETAILS } from "../api/apiPath";
import { hostName } from "../config/config";
import useGetClientId from "../hooks/useGetClientId";

const Sidebar = (props) => {
  const { clientNameParam } = useParams();
  // const inspectionRefNumber = localStorage.getItem("inspectionRefNumber");
  const { setHideSidebar, hideSidebar } = props;
  const navigate = useNavigate();
  const [profileImage, setProfileImage] = useState(null);
  const ImageProxyBaseUrl = hostName + "/api/Inspection/api/image?blobUrl=";

  const { userObj } = useSelector((state) => state.user);
  // const [searchParams] = useSearchParams();
  // const inspectionRefNumber = searchParams.get("inspectionRefNumber");
  // const dispatch = useDispatch();
  //const [isOpen, setIsOpen] = useState(false);
  const personaProps = {
    // imageUrl: userObj?.imageUrl ? userObj?.imageUrl : userIcon, // Replace with your image URL
    // text: userObj?.userName, // User's name
    imageUrl: profileImage || userIcon,
  };
  const clientObj = useGetClientId();

  useEffect(() => {
    if (!userObj?.userId) return;

    const fetchProfileImage = async () => {
      try {
        const response = await http.get(GET_USER_PROFILEDETAILS, {
          params: {
            clientId: userObj?.clientId,
            userId: userObj?.userId,
          },
        });

        if (response.status === 200 && response.data?.profileImage) {
          setProfileImage(
            ImageProxyBaseUrl + encodeURIComponent(response.data.profileImage)
          );
        }
      } catch (err) {
        console.error("Failed to load profile image", err);
      }
    };

    fetchProfileImage();
  }, [userObj?.userId]);

  const isClientValid =
    typeof clientNameParam === "string" &&
    clientNameParam.trim() !== "" &&
    clientNameParam !== null &&
    clientNameParam !== undefined;

  //  ADDED: Only redirect if userObj is missing AND we have a valid client param
  if (!userObj && isClientValid) {
    window.location.href = generatePath("/client/:clientNameParam/", {
      clientNameParam,
    });
    return;
  }

  const gotoprofile = () => {
    navigate(
      generatePath("/client/:clientNameParam/UserProfile", {
        clientNameParam,
      })
    );
  };

  // console.log("Calendar inspectionRefNumber:", inspectionRefNumber);

  return (
    <div
      className={"sideNavBar show"}
      style={{
        flex: "1 1 auto",
        minHeight: "0",
        overflowY: "auto",
        overflowX: "hidden",
        paddingRight: "6px",

        /* For Firefox only */
        scrollbarWidth: "thin",
        scrollbarColor: "rgba(255,255,255,0.3) transparent",
      }}
    >
      <div className="sidebar-header" style={{ marginTop: "-10px" }}>
        <img
          src={logo}
          alt="Assure Fire AI"
          className="sidebarLogo"
          onClick={() =>
            navigate(
              generatePath("/client/:clientNameParam/property-form", {
                clientNameParam,
              })
            )
          }
          style={{ cursor: "pointer" }}
        />
        <img src={navbarimg} className="navbar-toggler-icon " alt="logo" />
        <button
          className="toggle-btn burgerMenu"
          onClick={() => {
            setHideSidebar(!hideSidebar);
          }}
        >
          ☰
        </button>
      </div>
      {/* <div className="mb-5 ">
        <img src={finallogo} className="finalsidelogo" alt="logo" />
        <img
          src={sidebarlogo}
          className="sidelogo"
          alt="logo"
          //onClick={() => setIsOpen(!isOpen)}
          onClick={onToggle}
          style={{ cursor: "pointer" }}
        />
      </div> */}
      {/* <ul className="navbar-nav">
        <li className="nav-item mt-0 my-3">
          <a
            className="nav-link active"
            aria-current="page"
            href="/property-form"
          >
            <i className="fa-solid fa-house"></i>Dashboard
          </a>
        </li>
      </ul> */}
      {/* <p className="fs-6 fw-semibold mt-2 mb-2 text-start">ACCOUNT PAGES</p> */}
      <ul className="navbar-nav">
        <li
          className="nav-item ps-4"
          onClick={() => gotoprofile()}
          style={{ cursor: "pointer" }}
          title="View Profile"
        >
          <div style={{ display: "flex", alignItems: "center", gap: "0px" }}>
            <div className="px-2 ps-2" style={{ width: "32px" }}>
              <Persona
                {...personaProps}
                size={PersonaSize.size32}
                imageAlt="User profile picture"
              />
            </div>

            <div>
              <p className="ps-3 text-start" style={{ margin: 0 }}>
                {userObj?.userName}
              </p>
              <p
                className="ps-3 text-start"
                style={{
                  margin: 0,
                  fontSize: "12px",
                  color: "gray",
                  wordBreak: "break-all",
                  overflowWrap: "anywhere",
                  maxWidth: "100%",
                }}
              >
                {userObj.userEmail}
              </p>
            </div>
          </div>
        </li>
        {/* <li className="nav-item my-3" style={{marginLeft: "25px"}}>
          <button className="nav-link  p-0" aria-current="page" href="#">
            <i className="fa-solid fa-user"></i>Profile
          </button>
        </li> */}
        {/* <li className="nav-item my-3" style={{marginLeft: "25px"}}>
          <button
            className="nav-link p-0"
            aria-current="page"
            onClick={() => {
              navigate(
                  generatePath("/client/:clientNameParam/myBooking", {
                    clientNameParam,
                  })
                );
            }}
          >
            <i className="fa-solid fa-calendar"></i>My Bookings
          </button>
        </li> */}

        {/* {userObj?.isAdmin && (
          <li
            className="nav-item mb-2"
            style={{ marginLeft: "25px"}}
          >
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/QRCodes", {
                    clientNameParam,
                  })
                );
              }}
            >
            
              <img src={qrcodelogo} className="sidelogo" alt="logo" />
              <span className="menu-text ps-2">Generate QR </span>
            </button>
          </li>
        )} */}
        {userObj?.isAdmin && (
          <li className="nav-item mb-2" style={{ marginLeft: "25px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/adminDashboard", {
                    clientNameParam,
                  })
                );
              }}
            >
              <img src={adminlogo} className="sidelogo" alt="logo" />
              <span className="menu-text ps-2">Admin</span>
            </button>
          </li>
        )}

        {userObj?.isAdmin && (
          <li className="nav-item mb-2" style={{ marginLeft: "25px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/members", {
                    clientNameParam,
                  })
                );
              }}
            >
              {/* <img src={mem} className="sidelogo" alt="logo" />
              Members */}
              <img src={mem} className="sidelogo" alt="logo" />
              <span className="menu-text ps-2">Users</span>
            </button>
          </li>
        )}
        {userObj?.isAdmin && (
          <li className="nav-item mb-2" style={{ marginLeft: "25px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/addProperty", {
                    clientNameParam,
                  })
                );
              }}
            >
              <img src={pro} className="sidelogo" alt="logo" />
              <span className="menu-text ps-2">Properties</span>
            </button>
          </li>
        )}
        {/* {userObj?.isAdmin && (
          <li className="nav-item my-2">
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/inspectionDashboard", {
                    clientNameParam,
                  })
                );
              }}
            >
              <i className="fa-solid fa-building-user"></i>Inspection
            </button>
          </li>
        )} */}
        {/* {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{marginLeft: "25px"}}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/subscription", {
                    clientNameParam,
                  })
                );
              }}
            >
              <i className="fa-solid fa-credit-card"></i>Subscription
            </button>
          </li>
        )} */}
        {(userObj?.isAdmin || clientObj.roleId == 2) && (
          <li className="nav-item mb-2" style={{ marginLeft: "25px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/calendar", {
                    clientNameParam,
                  })
                );
              }}
            >
              <img src={CalendarClock} className="sidelogo" alt="logo" />
              <span className="menu-text ps-2">Calendar</span>
            </button>
          </li>
        )}
        {userObj?.isAdmin && (
          <li className="nav-item mb-2" style={{ marginLeft: "25px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/inspectionDashboard", {
                    clientNameParam,
                  })
                );
              }}
            >
              <img src={insplogo} className="sidelogo" alt="logo" />
              <span className="menu-text ps-2">Inspections</span>
            </button>
          </li>
        )}
   
        {userObj?.isAdmin && (
          <li className="nav-item mb-2" style={{ marginLeft: "25px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/leadDashboard", {
                    clientNameParam,
                  })
                );
              }}
            >
              <img src={lead} className="sidelogo" alt="logo" />
              <span className="menu-text ps-2">Bookings</span>
            </button>
          </li>
        )}
   {(userObj?.isAdmin ||  clientObj.roleId == 3) && (
          <li className="nav-item mb-2" style={{ marginLeft: "25px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/actionRemediation", {
                    clientNameParam,
                  })
                );
              }}
            >
              <img src={actonlogo} className="sidelogo" alt="logo" />
              <span className="menu-text ps-2">Action Plan</span>
            </button>
          </li>
        )}

        {/* <li className="nav-item my-3" style={{marginLeft: "25px"}}>
          <button className="nav-link p-0" aria-current="page" href="#">
            <i className="fa-solid fa-sign-in"></i>Sign In
          </button>
        </li>
        <li className="nav-item my-3" style={{marginLeft: "25px"}}>
          <button className="nav-link p-0" aria-current="page" href="#">
            <i className="fa-solid fa-rocket"></i>Sign Up
          </button>
        </li> */}

        {/* {userObj?.isAdmin && (
          <li className="nav-item my-3" style={{ marginLeft: "25px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/QRCodes", {
                    clientNameParam,
                  })
                );
              }}
            >
              <img src={qrcodelogo} className="sidelogo" alt="logo" />
              <span className="menu-text">Generate QR Code</span>
            </button>
          </li>
        )} */}

        {userObj?.isAdmin && (
          <li className="nav-item mb-2" style={{ marginLeft: "25px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() => {
                navigate(
                  generatePath("/client/:clientNameParam/ClientBranding", {
                    clientNameParam,
                  })
                );
              }}
            >
              {/* <img src={mem} className="sidelogo" alt="logo" />
              Members */}
              <img src={settings} className="sidelogo" alt="logo" />
              <span className="menu-text ps-2">Settings </span>
            </button>
          </li>
        )}

        {/* <li className="nav-item my-3" style={{ marginLeft: "25px" }}>
          <button
            className="nav-link p-0"
            aria-current="page"
            onClick={() =>
              dispatch(
                logoutUser({
                  userId: userObj?.userId,
                  userIdentifier: userObj?.userEmail,
                })
              )
            }
          >
            <img src={lout} className="sidelogo" alt="logo" />
            <span className="menu-text">Sign Out</span>
          </button>
        </li> */}
      </ul>
      <div
        className="menu_info_card mt-3"
        style={{
          backgroundImage: `url(${backgroundImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="col-12 mb-2 ">
          <img src={fra} className="sidelogo" alt="logo" />
        </div>
        <div className="col-12 mb-2">
          <p
            className=" fw-semibold mb-2"
            style={{ fontSize: "16px", color: "black" }}
          >
            Need Help?
          </p>
          <p
            className="fw-semibold mb-4"
            style={{ fontSize: "10px", color: "black" }}
          >
            Please check our documentation or connect with support.
          </p>
        </div>
        <div className="col-12">
          <button
            type="button"
            className="btn btn-light w-100"
            style={{
              color: "white",
              border: "none",
              fontSize: "11px",
              backgroundColor: "black",
            }}
          >
            Documentation
          </button>
          <button
            type="button"
            className="btn btn-light w-100 mt-2"
            style={{
              color: "white",
              border: "none",
              fontSize: "11px",
              backgroundColor: "black",
            }}
          >
            Connect with Support
          </button>
        </div>
      </div>
      {/* <div className="mt-auto">
        <ul className="navbar-nav">
          <li className="nav-item my-3" style={{ marginLeft: "25px" }}>
            <button
              className="nav-link p-0"
              aria-current="page"
              onClick={() =>
                dispatch(
                  logoutUser({
                    userId: userObj?.userId,
                    userIdentifier: userObj?.userEmail,
                  })
                )
              }
            >
              <img src={lout} className="sidelogo" alt="logo" />
              <span className="menu-text ps-2">Log Out</span>
            </button>
          </li>
        </ul>
      </div> */}
    </div>
  );
};

export default Sidebar;
